export const SearchResultsPageTestIds = {
  collectionSelectDrawer: 'collection-select-drawer',
  collectionSelectOption: 'collection-select-option',
  vipAdsSection: 'vip-ads-section',
  latestAdsSection: 'latest-ads-section',
};
